export default __webpack_public_path__ + "static/sac4.inspirations-2586f7c83fa4c1474c07cb1b5cf50d3d.jpg";